import { z } from 'zod'
import { type Expand } from '@/types/ui/expand'

export const engagementCreateSchema = z.object({
  engagementName: z.string().trim().min(1, 'Engagement name is required'),
  engagementCode: z.string().trim().min(1, 'Engagement code is required'),
})

export type EngagementCreateFormData = Expand<z.infer<typeof engagementCreateSchema>>

